import { Dispatch, SetStateAction, useState } from 'react'
import { PaginationInfo } from '../../NonReact/Types/Types'
import { AdminFilterValues } from '../Components/Molecules/AdminFilters/AdminFilters'
import { ReactState } from '../../React/Common/Types/Types'

export const DEFAULT_ROWS_PER_PAGE: number = 25

export type UseAdminStatState = {
    loading: number
    setLoading: Dispatch<SetStateAction<number>>
    sort: Definable<string>
    setSort: Dispatch<SetStateAction<Definable<string>>>
    filters: Nullable<AdminFilterValues>
    setFilters: Dispatch<SetStateAction<Nullable<AdminFilterValues>>>
    pagination: PaginationInfo
    setPagination: Dispatch<SetStateAction<PaginationInfo>>
    totalCount: number
    setTotalCount: Dispatch<SetStateAction<number>>
}

export function useAdminTableState(initialRowsPerPage = DEFAULT_ROWS_PER_PAGE) {
    const [loading, setLoading] = useState<number>(0)

    const [sort, setSort]: ReactState<Definable<string>> = useState<Definable<string>>()

    const [filters, setFilters]: ReactState<Nullable<AdminFilterValues>> = useState<Nullable<AdminFilterValues>>(null)

    const [pagination, setPagination]: ReactState<PaginationInfo> = useState<PaginationInfo>([0, initialRowsPerPage])

    const [totalCount, setTotalCount]: ReactState<number> = useState<number>(0)

    return {
        loading,
        setLoading,
        sort,
        setSort,
        filters,
        setFilters,
        pagination,
        setPagination,
        totalCount,
        setTotalCount
    }
}
